import React from 'react'

import { useSavePlaceType } from './_request/savePlaceType'
import { usePlaceType } from './_load/PlaceTypeLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditPlaceTypeForm = () => {
  const placetype = usePlaceType()
  const [onSubmit, { loading, error }] = useSavePlaceType()

  const initialState = placetype ? { ...placetype, document: [placetype.document] } : {}

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditPlaceTypeForm
